import { Auth0DecodedHash, Auth0Result, Auth0UserProfile } from 'auth0-js';
import ICombinedResponse from '../types/combinedResponse.d';
import CandidateEntity from '../types/entities/candidate.entity.d';
import EmployerDto from '../types/serverTypes/employerDto';
import { UserDto } from '../types/serverTypes/userDto';
import { InternalEntity } from '../types/entities/internal.entity';

// The session keeps the profile once, as Candidate or Employer, not again as GET /users sent it.
const withoutProfiles = {
  CandidateProfile: undefined,
  EmployerProfile: undefined,
};

export const combineResponsesCandidate = (
  auth0Response: Auth0DecodedHash | Auth0Result | Auth0UserProfile,
  serverUserResponse: UserDto,
  serverCandidateResponse?: CandidateEntity
): ICombinedResponse => ({
  auth0Response,
  serverUserResponse: {
    ...serverUserResponse,
    ...withoutProfiles,
    Candidate: serverCandidateResponse,
  },
  serverCandidateResponse: serverCandidateResponse ?? null,
  serverEmployerResponse: null,
  serverInternalResponse: null,
});

export const combineResponsesEmployer = (
  auth0Response: Auth0DecodedHash | Auth0Result | Auth0UserProfile,
  serverUserResponse: UserDto,
  serverEmployerResponse: EmployerDto
): ICombinedResponse => ({
  auth0Response,
  serverUserResponse: {
    ...serverUserResponse,
    ...withoutProfiles,
    Employer: serverEmployerResponse,
  },
  serverEmployerResponse: {
    ...serverEmployerResponse,
    brand: serverEmployerResponse.brand,
  },
  serverCandidateResponse: null,
  serverInternalResponse: null,
});

export const combineResponsesInternal = (
  auth0Response: Auth0DecodedHash | Auth0Result | Auth0UserProfile,
  serverUserResponse: UserDto,
  serverInternalResponse: InternalEntity
): ICombinedResponse => ({
  auth0Response,
  serverUserResponse: {
    ...serverUserResponse,
    ...withoutProfiles,
    Internal: serverInternalResponse,
  },
  serverEmployerResponse: null,
  serverCandidateResponse: null,
  serverInternalResponse,
});

export default combineResponsesCandidate;
